import { render, staticRenderFns } from "./bill-shell.vue?vue&type=template&id=c2d66d88&scoped=true"
import script from "./bill-shell.vue?vue&type=script&lang=js"
export * from "./bill-shell.vue?vue&type=script&lang=js"
import style0 from "./bill-shell.vue?vue&type=style&index=0&id=c2d66d88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2d66d88",
  null
  
)

export default component.exports